export const isLocaleSupported = () => Intl && 'Locale' in Intl;
